import { render, staticRenderFns } from "./saima_b.vue?vue&type=template&id=4f19be5c&scoped=true"
import script from "./saima_b.vue?vue&type=script&lang=js"
export * from "./saima_b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f19be5c",
  null
  
)

export default component.exports